import React, { useCallback, useMemo, useState } from 'react';

type SecurityState = {
  policies: string[];
  isSecurityLoading: boolean;
};

const normalizeSecurity = (security: any) => {
  const nextSecurity = security || {};
  const policies = Array.isArray(nextSecurity.policies) ? nextSecurity.policies : [];

  return { policies };
};

export const UserSecurityContext = React.createContext<any>(undefined);

export const UserSecurityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<SecurityState>({
    policies: [],
    isSecurityLoading: true
  });

  const setSecurity = useCallback((security: any) => setState((prev: any) => {
    const nextSecurity = normalizeSecurity(security);
    return { ...prev, ...nextSecurity, isSecurityLoading: false };
  }), []);

  const setIsSecurityLoading = useCallback((loading: boolean) => setState((prev: any) => {
    if (prev.isSecurityLoading === loading) {
      return prev;
    }
    return { ...prev, isSecurityLoading: loading };
  }), []);

  const value = useMemo(() => ({
    policies: state.policies,
    isSecurityLoading: state.isSecurityLoading,
    setSecurity,
    setIsSecurityLoading
  }), [state, setSecurity, setIsSecurityLoading]);

  return <UserSecurityContext.Provider value={value}>{children}</UserSecurityContext.Provider>;
};
